import _ from 'lodash';
import { createSelector } from 'reselect';

import { TpoStatusDefinitionKind } from 'constants/tpoStatusDefinitions';

import { getCompany } from './company.selectors';

const selectTpoStatusDefinitions = createSelector(
  getCompany,
  ({ tpoStatusDefinitions }) => tpoStatusDefinitions,
);

export const selectTpoStatusDefinitionsList = createSelector(
  selectTpoStatusDefinitions,
  ({ list }) => list,
);

const createKindSelector = kind =>
  createSelector(selectTpoStatusDefinitionsList, list =>
    _.sortBy(
      list.filter(definition => definition.kind === kind),
      'order',
    ),
  );

export const selectTpoMilestoneDefinitions = createKindSelector(TpoStatusDefinitionKind.MILESTONE);

export const selectTpoStatusKindDefinitions = createKindSelector(
  TpoStatusDefinitionKind.TPO_STATUS,
);
